'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  var pathToAdjudicators = ['one', action.aid];

  switch (action.type) {
    case 'GET_ADJUDICATORS_START':
      return state.setIn(pathToAdjudicators, (0, _immutable.fromJS)({ loading: true }));
    case 'GET_ADJUDICATORS':
      return state.setIn(pathToAdjudicators, (0, _immutable.fromJS)(action.payload));
    case 'GET_RESULTS':
      {
        return action.payload.reduce(function (state, data) {
          return state.setIn(['one', data.adj.id], (0, _immutable.fromJS)(data.adj));
        }, state);
      }
    case 'GET_FEIS_ADJUDICATORS':
    case 'GET_EVENT_ADJUDICATORS':
      {
        return action.payload.reduce(function (state, data) {
          return state.setIn(['one', data.id], (0, _immutable.fromJS)(data));
        }, state);
      }
    case 'GET_ALL_EVENT_SCORES':
      {
        return action.payload.reduce(function (state, data) {
          return state.setIn(['one', data.id], (0, _immutable.fromJS)({
            'fname': data.fname,
            'lname': data.lname,
            'id': data.id
          }));
        }, state);
      }
    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/adjudicators/index.js
// module id = 688
// module chunks = 0